export default "__VITE_ASSET__BwaUovBy__"